var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.5 4.89989C22.88 3.71989 25.14 3.71989 26.54 4.89989L29.7 7.61989C30.3 8.13989 31.42 8.55989 32.22 8.55989H35.62C37.74 8.55989 39.48 10.2999 39.48 12.4199V15.8199C39.48 16.5999 39.9 17.7399 40.42 18.3399L43.14 21.4999C44.32 22.8799 44.32 25.1399 43.14 26.5399L40.42 29.6999C39.9 30.2999 39.48 31.4199 39.48 32.2199V35.6199C39.48 37.7399 37.74 39.4799 35.62 39.4799H32.22C31.44 39.4799 30.3 39.8999 29.7 40.4199L26.54 43.1399C25.16 44.3199 22.9 44.3199 21.5 43.1399L18.34 40.4199C17.74 39.8999 16.62 39.4799 15.82 39.4799H12.36C10.24 39.4799 8.50001 37.7399 8.50001 35.6199V32.1999C8.50001 31.4199 8.08001 30.2999 7.58001 29.6999L4.88001 26.5199C3.72001 25.1399 3.72001 22.8999 4.88001 21.5199L7.58001 18.3399C8.08001 17.7399 8.50001 16.6199 8.50001 15.8399V12.3999C8.50001 10.2799 10.24 8.53989 12.36 8.53989H15.82C16.6 8.53989 17.74 8.11989 18.34 7.59989L21.5 4.89989Z",
    fill: "url(#paint0_linear_150_32993)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5801 30.3401C21.1801 30.3401 20.8001 30.1801 20.5201 29.9001L15.6801 25.0601C15.1001 24.4801 15.1001 23.5201 15.6801 22.9401C16.2601 22.3601 17.2201 22.3601 17.8001 22.9401L21.5801 26.7201L30.1801 18.1201C30.7601 17.5401 31.7201 17.5401 32.3001 18.1201C32.8801 18.7001 32.8801 19.6601 32.3001 20.2401L22.6401 29.9001C22.3601 30.1801 21.9801 30.3401 21.5801 30.3401Z",
    fill: "url(#paint1_linear_150_32993)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32993",
    x1: -21.9347,
    y1: 51.2645,
    x2: 58.4546,
    y2: -21.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32993",
    x1: 3.90504,
    y1: 32.6299,
    x2: 28.7895,
    y2: 1.33957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.0188f2f9e2e594654f6a9943a79869bc.svg";
export { ForwardRef as ReactComponent };